import { A as f } from "./SessionService-cbb226e7.mjs";
const u = function(o, t) {
  let n = {};
  if (o)
    if (o.ConfigService)
      ({ ConfigService: n } = o);
    else
      return o.ConfigService = n, t(n);
  return n;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(o) {
    let t = {};
    const n = (e) => {
      const { session: c } = f.getSession();
      let i = { ...t };
      const r = e ?? c.currentCountry;
      return r && (i = {
        ...i,
        ...t[r]
      }), i;
    }, s = (e) => {
      t = Object.assign(t, e);
    };
    return o.getConfigs = n, o.setConfigs = s, o;
  }
);
export {
  u
};
//# sourceMappingURL=ConfigService-10a172f7.mjs.map
